import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import 'flatpickr/dist/l10n/hu';
import { FlatpickrDirectiveBase } from '../flatpickrDirectiveBase';
import flatpickr from 'flatpickr';
import Options = flatpickr.Options.Options;

@Directive({
  selector: '[appDatePicker]',
})
export class DatepickerDirective extends FlatpickrDirectiveBase implements OnInit {
  @Input() options?: Options;

  constructor(private el: ElementRef) {
    super(el, 'datepicker');
  }

  ngOnInit() {
    this.init(this.options);
  }
}
